import { render, staticRenderFns } from "./WorkplaceOrServiceCalendar.vue?vue&type=template&id=4e919f34&"
import script from "./WorkplaceOrServiceCalendar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkplaceOrServiceCalendar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e919f34')) {
      api.createRecord('4e919f34', component.options)
    } else {
      api.reload('4e919f34', component.options)
    }
    module.hot.accept("./WorkplaceOrServiceCalendar.vue?vue&type=template&id=4e919f34&", function () {
      api.rerender('4e919f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceCalendar/WorkplaceOrServiceCalendar.vue"
export default component.exports